/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelInvitationActionResponseInvitation
 */
export interface CancelInvitationActionResponseInvitation {
    /**
     * 
     * @type {string}
     * @memberof CancelInvitationActionResponseInvitation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CancelInvitationActionResponseInvitation
     */
    status?: string;
}

/**
 * Check if a given object implements the CancelInvitationActionResponseInvitation interface.
 */
export function instanceOfCancelInvitationActionResponseInvitation(value: object): value is CancelInvitationActionResponseInvitation {
    return true;
}

export function CancelInvitationActionResponseInvitationFromJSON(json: any): CancelInvitationActionResponseInvitation {
    return CancelInvitationActionResponseInvitationFromJSONTyped(json, false);
}

export function CancelInvitationActionResponseInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelInvitationActionResponseInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function CancelInvitationActionResponseInvitationToJSON(json: any): CancelInvitationActionResponseInvitation {
    return CancelInvitationActionResponseInvitationToJSONTyped(json, false);
}

export function CancelInvitationActionResponseInvitationToJSONTyped(value?: CancelInvitationActionResponseInvitation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
    };
}

